import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import AIChat from "@/components/ai/ai-chat";
import { convex } from "@/lib/convex";
import { api } from "@/convex/_generated/api";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

const aiSearchSchema = z.object({
  thread: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/ai/_layout/")({
  validateSearch: aiSearchSchema,

  // Prefetch threads + sessions before the component mounts.
  // On repeated navigations the router cache (staleTime) avoids re-fetching.
  // Falls back gracefully if Convex isn't authenticated yet.
  loader: async () => {
    try {
      const [threads, mySessions] = await Promise.all([
        convex.query(api.companies.ai_agent.queries.listThreads, { limit: 50 }),
        convex.query(api.companies.chat.queries.listMySessions, {}),
      ]);
      return { threads: threads ?? [], mySessions: mySessions ?? [] };
    } catch {
      return { threads: [], mySessions: [] };
    }
  },

  // Keep loader data fresh for 30 s — Convex subscriptions update reactively anyway.
  staleTime: 30_000,

  component: AIChatPage,
});

function AIChatPage() {
  const { thread } = Route.useSearch();
  const loaderData = Route.useLoaderData();

  return (
    <RouteGuardPermissions
      permissions={[{ module: "ai_assistant", actions: ["read"] }]}
    >
      <AIChat threadId={thread} loaderData={loaderData} />
    </RouteGuardPermissions>
  );
}
